import type { InvoiceListRow } from "@themislex/shared";
import { useApi } from "../../api/hooks";
import { InvoiceTable } from "../../components/InvoiceTable";
import { Card, ErrorNote, Money, PageHeader, Spinner } from "../../components/ui";
import { useAuth } from "../../auth/AuthContext";

export default function ClientInvoices() {
  const { clientSelf } = useAuth();
  const { data, error, loading } = useApi<{ invoices: InvoiceListRow[] }>(
    "/api/invoices",
  );

  return (
    <>
      <PageHeader
        title="My invoices"
        subtitle="Invoices raised by the chambers on your matters."
        actions={
          clientSelf && clientSelf.balanceMinor > 0 ? (
            <div className="card px-4 py-2 text-sm">
              Balance payable:{" "}
              <Money minor={clientSelf.balanceMinor} className="font-semibold" />
            </div>
          ) : undefined
        }
      />

      {error && <ErrorNote>{error}</ErrorNote>}
      {loading && (
        <div className="flex justify-center py-16 text-muted">
          <Spinner className="h-6 w-6" />
        </div>
      )}

      {data && (
        <Card>
          <InvoiceTable
            invoices={data.invoices}
            emptyHint="No invoices have been raised for you yet."
          />
        </Card>
      )}
    </>
  );
}
